export const categories = [
  { id: 'all', name: '全部', slug: 'all' },
  { id: 'chigua', name: '吃瓜视频', slug: 'chigua' },
  { id: 'heiliaovideo', name: '黑料视频', slug: 'heiliaovideo' },
  { id: 'yiqu', name: '一区', slug: 'yiqu' },
  { id: 'erqu', name: '二区', slug: 'erqu' },
  { id: 'zhibo', name: '直播', slug: 'zhibo' },
  { id: 'yingshi', name: '影视', slug: 'yingshi' },
];

export const videos = [
  {
    id: 1,
    title: '最新娱乐圈大瓜速递：当红明星幕后故事全曝光',
    slug: 'latest-entertainment-scandal-1',
    category: 'chigua',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20studio%20with%20microphone%20and%20spotlight%2C%20dramatic%20lighting%2C%20professional%20video%20production%20setup%2C%20warm%20red%20and%20gold%20accents%2C%20cinematic%20atmosphere%2C%20modern%20broadcast%20studio%20background&width=640&height=360&seq=video-thumb-01&orientation=landscape',
    description: '娱乐圈再爆重磅消息，多位当红明星私生活细节曝光，吃瓜群众速来围观！本视频为你深度解析最新娱乐圈大事件，揭开明星幕后的真实面貌。',
    views: 125800,
    date: '2026-08-03',
    duration: '15:32',
    isHot: true,
    tags: ['娱乐圈', '明星八卦', '吃瓜'],
    content: '<p>娱乐圈从来不缺话题，而这一次的爆料更是让人瞠目结舌。据知情人士透露，近期多位当红明星的私生活被曝光，涉及感情纠纷、合约纠纷等多个方面。</p><p>本视频将为您详细梳理事件的来龙去脉，还原最真实的娱乐圈生态。从台前的光鲜亮丽到幕后的暗流涌动，让我们一起揭开这层神秘的面纱。</p><p>视频中包含了大量独家素材和深度分析，是近期最值得关注的黑料内容之一。</p>',
  },
  {
    id: 2,
    title: '黑料实锤：某顶流网红的翻车现场完整版',
    slug: 'influencer-scandal-exposed-2',
    category: 'heiliaovideo',
    thumbnail: 'https://readdy.ai/api/search-image?query=Social%20media%20scandal%20concept%2C%20dark%20moody%20lighting%2C%20cracked%20phone%20screen%20with%20warning%20symbols%2C%20dramatic%20red%20and%20black%20theme%2C%20news%20headlines%20background%2C%20thrilling%20atmosphere&width=640&height=360&seq=video-thumb-02&orientation=landscape',
    description: '千万粉丝网红人设崩塌全过程记录，实锤证据链完整呈现，带你了解网红圈的真实生态。',
    views: 89200,
    date: '2026-08-02',
    duration: '22:15',
    isHot: true,
    tags: ['网红', '翻车', '实锤'],
    content: '<p>在短视频时代，网红们精心打造的人设往往与真实情况相去甚远。本视频通过大量证据，完整还原了某顶流网红的翻车全过程。</p><p>从直播失误到社交账号异常，从粉丝质疑到内部爆料，每一个环节都有据可查。这不仅是一个网红的故事，更是整个行业的缩影。</p><p>观看本视频，你将看到网红经济背后的另一面。</p>',
  },
  {
    id: 3,
    title: '独家揭秘：综艺节目背后的剧本黑幕',
    slug: 'variety-show-behind-scenes-3',
    category: 'chigua',
    thumbnail: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20behind%20the%20scenes%2C%20stage%20crew%20and%20cameras%2C%20warm%20stage%20lighting%2C%20professional%20production%20environment%2C%20Chinese%20entertainment%20industry%2C%20dramatic%20backstage%20moment&width=640&height=360&seq=video-thumb-03&orientation=landscape',
    description: '综艺节目真的有剧本吗？知情人士独家爆料热门综艺的幕后操作手法，看完颠覆你的认知。',
    views: 67300,
    date: '2026-08-01',
    duration: '18:45',
    isHot: false,
    tags: ['综艺', '黑幕', '爆料'],
    content: '<p>综艺节目一直以来都声称是"真实记录"，但实际情况如何？本视频将为你揭开综艺节目制作的黑幕。</p><p>从选手淘汰到CP炒作，从冲突设计到煽情剧本，每一个"偶然"的背后都是精心设计的必然。多位业内人士首次发声，揭露行业潜规则。</p>',
  },
  {
    id: 4,
    title: '最新爆料：娱乐圈大佬与旗下艺人的秘密关系',
    slug: 'entertainment-boss-secrets-4',
    category: 'yiqu',
    thumbnail: 'https://readdy.ai/api/search-image?query=Mysterious%20luxury%20office%20interior%2C%20silhouette%20of%20people%20talking%20secretly%2C%20dramatic%20lighting%20through%20blinds%2C%20suspenseful%20atmosphere%2C%20film%20noir%20style%2C%20warm%20golden%20and%20deep%20red%20colors&width=640&height=360&seq=video-thumb-04&orientation=landscape',
    description: '娱乐圈大佬与旗下艺人的关系究竟是怎样的？深度揭秘娱乐圈权力结构与隐秘关系网。',
    views: 156300,
    date: '2026-07-31',
    duration: '25:10',
    isHot: true,
    tags: ['娱乐圈', '大佬', '秘密'],
    content: '<p>在娱乐圈这个名利场中，权力与关系构成了复杂的网络。本视频将深度剖析娱乐圈大佬与旗下艺人之间的真实关系。</p><p>从资源分配到利益交换，从台前合作到幕后博弈，我们将为你呈现一个真实的娱乐圈生态。</p>',
  },
  {
    id: 5,
    title: '网红带货翻车合集：那些年被坑的粉丝们',
    slug: 'livestream-shopping-fails-5',
    category: 'erqu',
    thumbnail: 'https://readdy.ai/api/search-image?query=Livestream%20shopping%20studio%20with%20products%20display%2C%20warning%20signs%2C%20dramatic%20contrast%20between%20promise%20and%20reality%2C%20split%20screen%20aesthetic%2C%20vibrant%20red%20accents%2C%20modern%20ecommerce%20scene&width=640&height=360&seq=video-thumb-05&orientation=landscape',
    description: '盘点各大网红直播带货的翻车名场面，虚假宣传、质量问题、售后无门，粉丝们的血泪教训。',
    views: 94300,
    date: '2026-07-30',
    duration: '20:30',
    isHot: false,
    tags: ['直播', '带货', '翻车'],
    content: '<p>直播带货是当下最火的商业模式之一，但其中的问题也层出不穷。本视频盘点了近年来最令人震惊的带货翻车事件。</p><p>从夸大宣传到以次充好，从天价坑位费到售后无门，我们将一一为你揭晓。</p>',
  },
  {
    id: 6,
    title: '2026年最火爆的网络热梗大盘点',
    slug: '2026-internet-memes-roundup-6',
    category: 'chigua',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20internet%20meme%20collage%2C%20viral%20social%20media%20trends%2C%20playful%20design%2C%20Chinese%20internet%20culture%2C%20bright%20and%20vibrant%20colors%2C%20pop%20art%20style&width=640&height=360&seq=video-thumb-06&orientation=landscape',
    description: '2026年上半年最火的网络热梗一次性看完，从\"我真的会谢\"到\"绝绝子\"，你错过了哪些？',
    views: 210500,
    date: '2026-07-29',
    duration: '12:50',
    isHot: true,
    tags: ['热梗', '网络文化', '盘点'],
    content: '<p>互联网从不缺梗，2026年更是热梗频出的一年。本视频为你整理了上半年最火的网络热梗和流行语。</p><p>从表情包到段子，从短视频BGM到流行句式，每一个热梗背后都反映了当下的社会心理和网络文化。</p>',
  },
  {
    id: 7,
    title: '直播圈内幕：大主播的真实收入大揭秘',
    slug: 'streamer-real-income-exposed-7',
    category: 'zhibo',
    thumbnail: 'https://readdy.ai/api/search-image?query=Luxury%20lifestyle%20contrast%20with%20streaming%20setup%2C%20money%20and%20gifts%20flying%20on%20screen%2C%20dramatic%20wealth%20display%2C%20golden%20and%20crimson%20color%20palette%2C%20streaming%20studio%20with%20professional%20equipment&width=640&height=360&seq=video-thumb-07&orientation=landscape',
    description: '你以为大主播月入百万？实际收入可能超乎你的想象！揭秘直播行业的真实收入层级。',
    views: 187200,
    date: '2026-07-28',
    duration: '16:40',
    isHot: true,
    tags: ['直播', '收入', '揭秘'],
    content: '<p>直播行业一直被认为是暴利行业，但主播们的真实收入到底有多少？本视频将为你全面揭秘。</p><p>从签约费到打赏分成，从广告费到带货佣金，我们将拆解主播收入的每一个组成部分，还原最真实的行业数据。</p>',
  },
  {
    id: 8,
    title: '黑料视频：某知名品牌代言人的双面人生',
    slug: 'brand-ambassador-double-life-8',
    category: 'heiliaovideo',
    thumbnail: 'https://readdy.ai/api/search-image?query=Split%20face%20mask%20concept%2C%20public%20persona%20vs%20private%20life%2C%20dramatic%20dual%20lighting%2C%20luxury%20brand%20advertisement%20contrast%2C%20dark%20and%20light%20duality%2C%20cinematic%20portrait%20style&width=640&height=360&seq=video-thumb-08&orientation=landscape',
    description: '台上光鲜亮丽，台下不堪入目？某国际品牌代言人的双面生活被曝光，人设崩塌只在一瞬间。',
    views: 143600,
    date: '2026-07-27',
    duration: '19:20',
    isHot: false,
    tags: ['品牌代言', '人设', '黑料'],
    content: '<p>品牌代言人在公众面前总是完美无缺，但镜头之外的他们又是怎样的？本视频揭露了某知名品牌代言人的真实面目。</p><p>从私生活混乱到商业欺诈，从人设包装到真实人格，巨大的反差令人震惊。</p>',
  },
  {
    id: 9,
    title: '影视圈潜规则：演员试镜背后的交易内幕',
    slug: 'film-industry-casting-secrets-9',
    category: 'yingshi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Film%20casting%20room%20with%20dramatic%20shadows%2C%20camera%20and%20director%20chair%2C%20mysterious%20atmosphere%2C%20Hollywood%20film%20noir%20lighting%2C%20warm%20golden%20and%20deep%20shadow%20contrast&width=640&height=360&seq=video-thumb-09&orientation=landscape',
    description: '演员试镜不只是看演技？揭秘影视圈选角背后的各种交易和潜规则，让你看清这个行业的真实面目。',
    views: 112400,
    date: '2026-07-26',
    duration: '23:15',
    isHot: false,
    tags: ['影视', '试镜', '潜规则'],
    content: '<p>在影视行业，选角从来不只是看演技那么简单。本视频深入揭秘了影视圈选角过程中的各种交易和潜规则。</p><p>从带资进组到关系户，从利益交换到行业默契，我们将为你还原一个真实的影视圈生态。</p>',
  },
  {
    id: 10,
    title: '吃瓜速递：本周娱乐圈十大爆点事件回顾',
    slug: 'weekly-entertainment-roundup-10',
    category: 'chigua',
    thumbnail: 'https://readdy.ai/api/search-image?query=Weekly%20news%20headlines%20collage%2C%20entertainment%20magazine%20cover%20style%2C%20breaking%20news%20graphics%2C%20bold%20typography%2C%20warm%20red%20and%20gold%20accents%2C%20editorial%20design&width=640&height=360&seq=video-thumb-10&orientation=landscape',
    description: '一周娱乐圈大事记，从恋情曝光到新剧官宣，精彩不容错过！快速回顾本周所有热点。',
    views: 201300,
    date: '2026-07-25',
    duration: '14:55',
    isHot: true,
    tags: ['周报', '娱乐圈', '热点'],
    content: '<p>本周娱乐圈可谓是精彩纷呈，各种大事件接连不断。本视频为你快速回顾本周十大爆点事件。</p><p>从明星恋情到新剧官宣，从综艺争议到社会热点，一条视频让你不错过任何精彩内容。</p>',
  },
  {
    id: 11,
    title: '深度分析：选秀节目的票数造假产业链',
    slug: 'talent-show-vote-fraud-11',
    category: 'yiqu',
    thumbnail: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20voting%20screens%2C%20suspicious%20data%20charts%2C%20dramatic%20spotlight%2C%20reality%20TV%20atmosphere%2C%20golden%20and%20deep%20red%20lighting%2C%20investigative%20journalism%20style&width=640&height=360&seq=video-thumb-11&orientation=landscape',
    description: '选秀节目的票数真的公正吗？深度调查投票造假产业链，从数据造假到粉丝经济的黑暗面。',
    views: 98700,
    date: '2026-07-24',
    duration: '21:00',
    isHot: false,
    tags: ['选秀', '造假', '产业链'],
    content: '<p>选秀节目一直是热门话题，但其中的票数造假问题也由来已久。本视频深度调查了选秀节目背后的造假产业链。</p><p>从技术手段到商业逻辑，从平台默许到粉丝买单，完整的造假链条令人触目惊心。</p>',
  },
  {
    id: 12,
    title: '直播界的隐秘江湖：公会与主播的恩怨情仇',
    slug: 'streaming-guild-drama-12',
    category: 'zhibo',
    thumbnail: 'https://readdy.ai/api/search-image?query=Streaming%20studio%20with%20multiple%20screens%2C%20intense%20negotiation%20scene%2C%20corporate%20drama%20atmosphere%2C%20warm%20amber%20lighting%2C%20professional%20gaming%20setup%2C%20behind%20the%20scenes%20business&width=640&height=360&seq=video-thumb-12&orientation=landscape',
    description: '主播与公会之间的关系远比你想象的复杂，从签约陷阱到利益分配，揭开直播公会的真实运作。',
    views: 76500,
    date: '2026-07-23',
    duration: '17:30',
    isHot: false,
    tags: ['直播', '公会', '利益'],
    content: '<p>在直播行业中，公会扮演着至关重要的角色。但公会与主播之间的关系，往往充满了利益纠葛和恩怨情仇。</p><p>从签约时的"画饼"到分成时的"克扣"，从资源倾斜到雪藏封杀，本视频为你还原最真实的公会生态。</p>',
  },
];

export const hotTags = [
  { name: '娱乐圈大瓜', count: 1250 },
  { name: '网红翻车', count: 980 },
  { name: '综艺黑幕', count: 756 },
  { name: '直播带货', count: 632 },
  { name: '明星恋情', count: 521 },
  { name: '选秀造假', count: 487 },
  { name: '品牌代言', count: 398 },
  { name: '网络热梗', count: 365 },
];

export const siteInfo = {
  name: '51黑料',
  description: '51黑料 - 最全的吃瓜视频与黑料视频聚合平台，提供高清流畅的在线观看体验。覆盖娱乐圈、网红圈、直播圈等多领域黑料内容，让你不错过任何一个热点。',
  logo: '51黑料',
  email: 'contact@51heiliao.com',
  founded: '2020',
  stats: {
    videos: 50000,
    users: 2000000,
    dailyViews: 5000000,
  },
};